import { render, staticRenderFns } from "./DashBoardInventarioThymos.vue?vue&type=template&id=c3c0ffda&scoped=true&"
import script from "./DashBoardInventarioThymos.vue?vue&type=script&lang=js&"
export * from "./DashBoardInventarioThymos.vue?vue&type=script&lang=js&"
import style0 from "./DashBoardInventarioThymos.vue?vue&type=style&index=0&id=c3c0ffda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c0ffda",
  null
  
)

export default component.exports